import { getServiceUrl } from '../api.config';
import { ApiClientOptions } from '../types/api';
import ApiClient from '../utils/ApiClient';
import qs from '../utils/query';

export default class KindApi extends ApiClient {
  public constructor(options?: ApiClientOptions) {
    super(getServiceUrl('core'), options);
  }

  // =============================================================================
  //                            Kind APIS
  // =============================================================================

  public KindList() {
    const query = '/core/v3/kinds';
    return this.get(query);
  }

  public KindSpecific(kindId: number, parameters: any) {
    const query = `/core/v3/kinds/${kindId}`;
    return this.get(query, qs.stringify(parameters, true));
  }

  public KindUpdate(kind: any) {
    const query = `/core/v3/kinds/${kind.id}`;
    return this.put(query, kind);
  }
}
